module.exports = __webpack_public_path__ + "static/media/cloud-hero.0435cd64.jpg";